type Props = {
  paymentType: string
  creditLimit: number
}

const PaymentCell = ({paymentType, creditLimit}: Props) => {
  return (
    <div className=''>
      <p className='fs-4 m-0'>{paymentType === '0' ? 'Prepaid' : 'Postpaid'}</p>
      {paymentType === '1' && (
        <>
          <p className='fs-6 m-0'>{creditLimit}</p>
          <p className='fs-6 m-0'>(Credit Limit)</p>
        </>
      )}
    </div>
  )
}

export default PaymentCell
